import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import {TabViewCustom} from '../../../_models/tab-view-custom';

@Component( {
  selector: 'app-flujo-venta-segmento',
  templateUrl: 'flujo-venta-segmento.component.html'
} )

export class FlujoVentaSegmentoComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Output() actualizarSecuencia: EventEmitter<any> = new EventEmitter<any>();
  @Input() titulo: string;
  tabSeleccionado = 'PASO';

  constructor() {
  }

  ngOnInit() {
  }

  abrirAcordeon( index: number ) {
    switch ( index ) {
      case 0: {
        this.tabSeleccionado = 'PASO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'RESPERXVIN';
        break;
      }
    }
  }
}
